import { Quaternion } from "@babylonjs/core/Maths/math.vector";

/**
 * Extract the Y-axis (yaw) component from a rotation quaternion using
 * swing-twist decomposition around (0, 1, 0). The result is the rotation
 * that, composed with a swing around the horizontal plane, reproduces the
 * input — i.e. the pure yaw.
 *
 * Handles the singularity near zero-length projection by returning identity.
 *
 * @param q Source rotation.
 * @param out Optional destination. A new Quaternion is allocated if omitted.
 */
export function projectQuaternionToYaw(q: Quaternion, out?: Quaternion): Quaternion {
    const result = out ?? new Quaternion();
    const y = q.y;
    const w = q.w;
    const len = Math.sqrt(y * y + w * w);
    if (len > 1e-6) {
        result.set(0, y / len, 0, w / len);
    } else {
        result.set(0, 0, 0, 1);
    }
    return result;
}
